import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://zrqqhaolkjzcwindhtoy.supabase.co";
const SUPABASE_ANON_KEY = "sb_publishable_9d3nLNMmCaMl0khCRjGS2Q_SUxAd4r2";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);